









import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import PriceConfig from '@/dto/price_config/PriceConfig'
import PriceConfigFactory from '@/services/factories/PriceConfigFactory'
import PriceConfigForm from '@/components/price-config/PriceConfigForm.vue'

@Component({
  components: { PriceConfigForm },
})
export default class PriceConfigCreate extends Vue {
  model: PriceConfig = PriceConfigFactory()
}
